import React, { useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Button, Typography } from '@mui/material'
import clsx from 'clsx'
import { triggerDemoModeInitiator } from '../../../redux/actions/DemoModeActions'
import { initiateDemoTlc } from '../../../api/consultation'
import DefaultDialog from '../../common/DefaultDialog'
import styles from './styles/DemoModeStartDialogStyles'

import { useAppDispatch, useAppSelector } from '../../../store'
import { ConsultationWhiteIcon, TransmissionColorIcon } from '../../../../assets/icons'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { DemoModeStartD... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

const DemoModeStartDialog = () => {
    const classes = useStyles()
    const dispatch = useAppDispatch()
    const [disabledStartDemonstrationButton, setDisabledStartDemonstrationButton] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)
    const demoModeStore = useAppSelector((state) => state.demoMode)

    const { isDemoModeInitiatorOn } = demoModeStore

    const introText =
        'Cet espace vous permet de démarrer des téléconsultations / téléexepertises (à venir) de démonstration.'

    const handleClose = async () => {
        dispatch(triggerDemoModeInitiator(false))
        setDisabledStartDemonstrationButton(false)
        setErrorMessage(null)
    }

    const handleStartDemoMode = async () => {
        if (!disabledStartDemonstrationButton) {
            try {
                await initiateDemoTlc()
                setErrorMessage(null)
                dispatch(triggerDemoModeInitiator(false))
            } catch (e) {
                console.log('e: ', e)
                // @ts-expect-error TS(2345) FIXME: Argument of type '"Une erreur s'est produite lors ... Remove this comment to see the full error message
                setErrorMessage("Une erreur s'est produite lors du démarrage de la téléconsultation de démonstration.")
                setDisabledStartDemonstrationButton(false)
            }
        }
        setDisabledStartDemonstrationButton(false)
    }

    return (
        <DefaultDialog handleClose={handleClose} open={isDemoModeInitiatorOn} largePadding>
            <div className={classes.DemoModeStartDialogTitleContainer}>
                <Typography className={classes.DemoModeStartDialogOverText}>Testez en toute sérénité</Typography>
                <Typography className={classes.DemoModeStartDialogTitle}>Mode démonstration</Typography>
            </div>
            <div>
                <div className={classes.DemoModeStartDialogIntro}>
                    <Typography>{introText}</Typography>
                </div>
                <div className={classes.DemoModeStartDialogButtons}>
                    <div className={classes.DemoModeStartDialogButton}>
                        <Button
                            className={clsx(
                                classes.DemoModeStartDialogButtonButton,
                                classes.DemoModeStartDialogButtonButtonActive,
                            )}
                            variant="contained"
                            disableElevation
                            color="secondary"
                            disabled={disabledStartDemonstrationButton}
                            data-cy="demoModeDialogStartTlcBtn"
                            onClick={() => {
                                setDisabledStartDemonstrationButton(true)
                                handleStartDemoMode()
                            }}
                        >
                            <ConsultationWhiteIcon className={classes.DemoModeStartDialogButtonIcon} />
                            <span className={classes.DemoModeStartDialogButtonText}>
                                Démarrer une téléconsultation (TLC) de démonstration
                            </span>
                        </Button>
                    </div>
                    {/* @ts-expect-error TS(2551) FIXME: Property 'DemoModeStartDialogButtonsSeparator' doe... Remove this comment to see the full error message */}
                    <div className={classes.DemoModeStartDialogButtonsSeparator} />
                    <div className={clsx(classes.DemoModeStartDialogButton, classes.DemoModeStartDialogButtonDisabled)}>
                        <Button
                            className={clsx(
                                classes.DemoModeStartDialogButtonButton,
                                classes.DemoModeStartDialogButtonButtonDisabled,
                                classes.DemoModeStartDialogButtonButtonAlternative,
                            )}
                            disabled
                            variant="contained"
                            disableElevation
                        >
                            <TransmissionColorIcon className={classes.DemoModeStartDialogButtonIcon} />
                            <span className={classes.DemoModeStartDialogButtonText}>
                                Démarrer une téléexpertise (TLE) de démonstration
                            </span>
                        </Button>
                        <Typography className={classes.DemoModeStartDialogButtonDisabledText}>
                            Fonctionnalité à venir
                        </Typography>
                    </div>
                </div>
                {errorMessage && (
                    <div className={classes.DemoModeStartDialogErrorMessage}>
                        <Typography>{errorMessage}</Typography>
                    </div>
                )}
            </div>
        </DefaultDialog>
    )
}

export default DemoModeStartDialog
